import Details from './details/ClientBillingDetailsInitialState'

const { Record } = require('immutable')

export default Record({
    details: Details()
})